import { useQuery } from '@apollo/client';
import { getMultiBuildingTaskFilterAttributesQuery } from 'graphql-queries';

export interface SelectOption {
  id: string;
  name: string;
}

export type MultiBuildingTaskFilterOptions = {
  schedules: SelectOption[];
  statuses: string[];
  equipments: SelectOption[];
  assignees: SelectOption[];
  locations: string[];
  transitionStatuses: string[];
};

interface MultiBuildingTaskFilterAttributesData {
  multiBuildingTaskFilterAttributes: MultiBuildingTaskFilterOptions;
}

export interface UseMultiBuildingTaskFilterAttributesParams {
  channelIds?: string[];
}

export interface UseMultiBuildingTaskFilterAttributesResult {
  filterOptions: MultiBuildingTaskFilterOptions;
  loading: boolean;
  error: ReturnType<typeof useQuery>['error'];
}

const emptyFilterOptions: MultiBuildingTaskFilterOptions = {
  schedules: [],
  statuses: [],
  equipments: [],
  assignees: [],
  locations: [],
  transitionStatuses: [],
};

export function useMultiBuildingTaskFilterAttributes(
  params: UseMultiBuildingTaskFilterAttributesParams
): UseMultiBuildingTaskFilterAttributesResult {
  const { data, loading, error } =
    useQuery<MultiBuildingTaskFilterAttributesData>(
      getMultiBuildingTaskFilterAttributesQuery,
      {
        variables: {
          channelIds: params.channelIds,
        },
        fetchPolicy: 'network-only',
      }
    );

  return {
    filterOptions: data?.multiBuildingTaskFilterAttributes ?? emptyFilterOptions,
    loading,
    error,
  };
}
